export const experienceData = [
    {
        id: 1,
        company: 'Turing',
        jobtitle: 'RL-Gym Developer & Agentic AI Trainer',
        startYear: 'Nov 2024',
        endYear: 'Feb 2026',
        roles: [
            {
                title: 'RL-Gym Developer & Environment Engineer',
                bullets: [
                    'Designed and built reinforcement learning environments (RL-gyms) using FastAPI, enabling AI agents to learn complex multi-step workflows across platforms including Google Drive, Databricks, Asana, Reddit, and Walmart Marketplace.',
                    'Engineered complete database schemas in PostgreSQL with SQLAlchemy, accurately representing real-world constraints, relationships, and business rules for agent training scenarios.',
                    'Developed FastAPI-based tool endpoints exposing realistic platform functionalities with proper authentication, error handling, and state management.',
                    'Built sophisticated data seeding scripts generating realistic, constraint-compliant datasets aligned with production patterns and business logic.',
                    'Designed reward structures and training scenarios that guide agents toward optimal decision-making while enforcing policy compliance and handling edge cases.',
                ],
                technologies: 'FastAPI, Python, PostgreSQL, SQLAlchemy, Docker, RESTful API Design, Reinforcement Learning',
            },
            {
                title: 'Pod Lead – Agentic AI',
                bullets: [
                    'Managed and mentored a team of six Agentic AI trainers, conducting performance reviews and providing targeted coaching to drive both individual growth and collective throughput goals.',
                    'Aligned pod deliverables with organizational objectives, ensuring consistent quality across RLHF (Meta), SFT/FC/CIF (ServiceNow), and Agentic Systems training pipelines.',
                    'Championed structured prompt engineering, tool schema design, and agentic design patterns (ReAct, Plan-and-Execute, Defined Workflow Agents) across the team.',
                ],
            },
        ],
    },
    {
        id: 2,
        company: 'Deveint Limited',
        jobtitle: 'Software Engineer',
        startYear: 'Jul 2024',
        endYear: 'Nov 2024',
        details: [
            'Built and maintained backend services using Python (Django, FastAPI) with PostgreSQL and MySQL, delivering RESTful APIs consumed by React.js and Next.js frontends.',
            'Performed software testing and authored QA reports, ensuring release quality and identifying regressions before deployment.',
            'Contributed to DevOps workflows including Nginx/Apache configuration and scripting-based automation tasks.',
        ],
        technologies: 'Python, Django, FastAPI, PostgreSQL, MySQL, React.js, Next.js, Nginx, Apache',
    },
    {
        id: 3,
        company: 'Project Kibhoret (GAKL)',
        jobtitle: 'Lead Engineer / Project Owner',
        startYear: 'Aug 2024',
        endYear: 'Present',
        link: 'https://kibhoret.cellent.tech',
        details: [
            'Designed and led development of a Material Management System for crude palm oil tracking from port to factory, covering loading, quality control, weighbridge, and offloading checkpoints.',
            'Delivered full-stack solution using Django and PostgreSQL (backend) and Next.js (frontend), with role-based access controls and real-time status updates.',
        ],
        technologies: 'Django, PostgreSQL, Next.js, REST',
    },
    {
        id: 4,
        company: 'Project Olkisir',
        jobtitle: 'Backend Lead',
        startYear: 'Jul 2023',
        endYear: 'Present',
        link: 'https://olkisir.koech.tech',
        details: [
            'Led backend development for a Dispatch and Returns System managing end-to-end sales order fulfillment and product return workflows.',
            'Implemented secure API layer using Django, MySQL, and JWT authentication with Axios-driven frontend integration.',
        ],
        technologies: 'Django, MySQL, JWT, Axios, REST',
    },
    {
        id: 5,
        company: 'Golden Africa Kenya Limited',
        jobtitle: 'In-Process Quality Assurance Chemist',
        startYear: 'Sept 2017',
        endYear: 'Oct 2020',
        details: [
            'Conducted rigorous physical and chemical testing of raw and finished materials in collaboration with cross-functional production teams.',
            'Managed market returns, dispatch quality assurance, and complaint resolution to maintain compliance and customer satisfaction.',
            'Oversaw sampling and archiving processes to ensure data integrity and regulatory compliance.',
        ],
    },
];
